const FONTS = [
  'IBM Plex Sans',
  'Inter',
  'Poppins',
  'Montserrat',
  'Playfair Display',
  'DM Sans',
  'Space Grotesk',
  'Plus Jakarta Sans',
  'Outfit',
  'Sora',
];

interface FontSelectorProps {
  label: string;
  value: string;
  onChange: (font: string) => void;
}

export default function FontSelector({ label, value, onChange }: FontSelectorProps) {
  return (
    <div>
      <label className="block font-mono text-[10px] uppercase tracking-widest mb-1.5" style={{ color: 'var(--dash-text-dim)' }}>{label}</label>
      <select
        value={value || 'IBM Plex Sans'}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded px-3 py-2 font-sans text-sm focus:outline-none transition-colors"
        style={{
          border: '1px solid var(--dash-border)',
          background: 'var(--dash-input)',
          color: 'var(--dash-select-text)',
        }}
      >
        {FONTS.map((font) => (
          <option key={font} value={font}>{font}</option>
        ))}
      </select>
    </div>
  );
}
